import { ToolbarProps } from "elements/base/provider";
import { IconElement } from "../schema";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function IconToolbar({ ids, elements, context }: ToolbarProps<IconElement>) {
  return <></>;
}
